import { defineMessages } from 'react-intl';

export default defineMessages({
	signupWarningMessage: {
		defaultMessage: 'Before you can send this request, {signUpLink} to continue',
		description: 'Message to redirect to sign up page before creating request.',
		id: 'cv.request.create.form.anonymousEmail.signupWarningMessage',
	},
	signupLink: {
		defaultMessage: 'sign up',
		description: 'Label for the sign up link in the anonymous email signup warning message.',
		id: 'cv.request.create.form.anonymousEmail.signupLink',
	},
});
